module.exports = __webpack_public_path__ + "resources/img/img_sqml_di2_m_en.d3e5537a10f81ad7898e1b3ee973cd9d.png";